<template lang="pug">
    .component-backoffice-card
        table
            thead
                th Id
                th Name
                th Type
                th Count
            tbody
                tr(v-for="time in item.time_rates")
                    td {{time.rate.id}}
                    td {{time.rate.name}}
                    td Time
                    td
                        span.badge.success {{time.count}}
                tr(v-for="distance in item.distance_rates")
                    td {{distance.rate.id}}
                    td {{distance.rate.name}}
                    td Distance
                    td
                        span.badge.success {{distance.count}}
</template>
<script type="text/babel">

    export default{
        name: "AppliedRates",
        components: {
        },
        data(){
            return {}
        },
        created() {
        },
        methods: {},
        computed: {},
        props:['item']
    }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>


// WEBPACK FOOTER //
// AppliedRates.vue?4f25c358